import { Avatar } from "~/components/ui/avatar";

/** Assignee avatar; renders nothing when unassigned. */
export function AssigneeAvatar({
  name,
  avatarUrl,
  className,
}: {
  readonly name: string | null;
  readonly avatarUrl: string | null;
  readonly className?: string;
}) {
  if (!name) return null;
  return <Avatar name={name} src={avatarUrl} className={className ?? "size-5 text-[9px]"} />;
}
